import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap';
import { ToasterService } from 'angular2-toaster';
import { HaModelColorService } from '../../../services/index';

@Component({
    selector: 'add-edit-ha-model-color',
    templateUrl: './addEditHaModelColor.component.html'
})
export class AddEditHaModelColorComponent implements OnInit {

    @Output() haModelColorLoadEvent = new EventEmitter();

    public title: string;
    public haModelColorData: any = {};
    public isLoading: boolean = false;

    statusOptions = ['Active', 'Inactive'];

    constructor(
        public bsModalRef: BsModalRef,
        public toasterService: ToasterService,
        private haModelColorService: HaModelColorService
    ) { }

    ngOnInit(): void {
        if (this.haModelColorData.mode === 'Add') {
            this.haModelColorData.status = 'Active';
        }
    }

    onSave(): void {
        this.isLoading = true;

        let params = {
            mode: this.haModelColorData.mode,
            name: this.haModelColorData.name,
            status: this.haModelColorData.status
        };

        if (this.haModelColorData.mode === 'Edit') {
            params['id'] = this.haModelColorData.id;
        }

        this.haModelColorService
            .addUpdateHaModelColor(params)
            .then((res: any) => {
                this.isLoading = false;
                if (res && res.success) {
                    this.toasterService.pop({
                        type: 'success',
                        title: 'Success',
                        body: res.message
                    });
                    this.haModelColorLoadEvent.emit();
                    this.bsModalRef.hide();
                } else {
                    this.toasterService.pop({
                        type: 'error',
                        title: 'Error',
                        body: res.message || 'Something went wrong'
                    });
                }
            })
            .catch(() => {
                this.isLoading = false;
                this.toasterService.pop({
                    type: 'error',
                    title: 'Error',
                    body: 'Something went wrong'
                });
            });
    }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/master/haModelColor/addEditHaModelColor.component.ts